$(function () {
  'use strict';
  //
  //Extension
  //
  $.ui.autocomplete.prototype._renderItem = function (ul, item) {
    return $('<li></li>').data('item.autocomplete', item).append($('<a></a>').html(item.label)).appendTo(ul);
  };

  $.ui.autocomplete.prototype._resizeMenu = function () {
    var ul = this.menu.element;
    ul.outerWidth(this.element.outerWidth());
  };

  $('#search-users').autocomplete({

    source: function (request, response) {
      if (!request.term) {
        $(this).attr('autocomplete', 'off');
      }
      $.get('/users/search.json', { keyword: request.term }, function (data) {
        response(data.map(function (value) {
          return {
            label: ''
            + '<div class="department__member-image">'
            + '<img class="user-image user-image--45 img--circled" alt="' + value.user.name + '" width="45" height="45" src=' + value.user.image_path + '>'
            + '</div>'
            + '<div class="department__member-desc">'
            + '<p class="department__member-name">' + value.user.name + '</p>'
            + '<p class="department__member-info">' + value.user.department + '</p>'
            + '</div>',
            value: value.user.name,
            url: value.user.profile_path,
          };
        }));
      });
    },
    create: function () {
      // aware tap twice (double tap) on iOS
      if (navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/Android/)) {
        $('.ui-autocomplete').off('menufocus hover mouseover mouseenter');
      }

      $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
        return $('<li>')
        .attr('data-value', item.value)
        .attr('data-url', item.url)
        .append('<a style="display:block;width:100%;" href=' + item.url + '>' + item.label + '</a>')
        .appendTo(ul);
      };
    },
    select: function (event, ui) {
      window.location.href = ui.item.url;
    },
    autoFocus: false,
    delay: 500,
    minLength: 1,
  });
});
